import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, matchRoutes, useLocation, useSearchParams } from "react-router-dom";
import { LEGACY_ROUTES } from "./Shared/components/Navigation/navigationUtils";
const oldGiftCardRoute = [{ path: LEGACY_ROUTES.GIFT_CARD }];
/**
 * There are marketing sites that still link to old URls.
 * This component redirects the user to the new equivalent route if it exists.
 * @returns
 */
export const RedirectionOutlet = () => {
    var _a;
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const isOldGiftCardRoute = matchRoutes(oldGiftCardRoute, location);
    const skuParam = (_a = searchParams.get("sku")) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    // Redirect to Gift Card page if using old route
    if (!!isOldGiftCardRoute) {
        return _jsx(Navigate, { to: `/gift`, relative: "path" });
    }
    if (!!skuParam) {
        // Redirect to location page if using a potential flow sku
        if (skuParam !== "gift") {
            return _jsx(Navigate, { to: `/${searchParams.get("sku")}/Location`, relative: "path" });
        }
        // Redirect to Gift Card page if using GIFT sku
        if (skuParam === "gift") {
            return _jsx(Navigate, { to: `/gift`, relative: "path" });
        }
    }
    // Return Outlet to show desired route if none of the above are hit
    return _jsx(Outlet, {});
};
